import api from 'api';

export interface ComplianceWrapperSchema {
  businessesId: number;
  modifiedBy: string;
  complianceReference: string;
}

export const complianceWrapper = async (data: ComplianceWrapperSchema) => {
  return api.put('Compliance/ComplianceWrapper', data);
};

export default {
  complianceWrapper,
};
